import React from 'react';
import { Modal, View, Text, Pressable, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

interface Props {
    visible: boolean;
    onViewPartnerships: () => void;
    onGoToDashboard: () => void;
}

const PartnershipActivatedModal: React.FC<Props> = ({ visible, onViewPartnerships, onGoToDashboard }) => {
    return (
        <Modal
            visible={visible}
            animationType="fade"
            transparent={true}
        >
            <View style={styles.modalOverlay}>
                <View style={styles.modalContainer}>
                    {/* Success Icon */}
                    <View style={styles.iconContainer}>
                        <View style={styles.iconCircle}>
                            <Ionicons name="checkmark" size={48} color="#51B868" />
                        </View>
                    </View>

                    {/* Title */}
                    <Text style={styles.title}>Partnership Activated!</Text>

                    {/* Message */}
                    <Text style={styles.message}>
                        You've successfully accepted the Split Partner Terms and Conditions.
                    </Text>

                    {/* Benefits List */}
                    <View style={styles.benefitsList}>
                        <Text style={styles.benefitsTitle}>You can now:</Text>
                        
                        <View style={styles.benefitItem}>
                            <Ionicons name="checkmark-circle" size={20} color="#51B868" />
                            <Text style={styles.benefitText}>View charger earnings</Text>
                        </View>
                        
                        <View style={styles.benefitItem}>
                            <Ionicons name="checkmark-circle" size={20} color="#51B868" />
                            <Text style={styles.benefitText}>Access transaction history</Text>
                        </View>
                        
                        <View style={styles.benefitItem}>
                            <Ionicons name="checkmark-circle" size={20} color="#51B868" />
                            <Text style={styles.benefitText}>Receive revenue split payouts</Text>
                        </View>
                    </View>

                    {/* Email Notice */}
                    <View style={styles.emailNotice}>
                        <Ionicons name="mail-outline" size={18} color="#39BEB7" />
                        <Text style={styles.emailNoticeText}>
                            A copy of the agreement has been sent to your email for your records.
                        </Text>
                    </View>

                    {/* Action Buttons */}
                    <View style={styles.actionButtons}>
                        <Pressable
                            style={styles.secondaryButton}
                            onPress={onGoToDashboard}
                        >
                            <Text style={styles.secondaryButtonText}>Go to Dashboard</Text>
                        </Pressable>

                        <Pressable
                            style={styles.primaryButton}
                            onPress={onViewPartnerships}
                        >
                            <Text style={styles.primaryButtonText}>View My Partnerships</Text>
                        </Pressable>
                    </View>
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    modalContainer: {
        width: '100%',
        maxWidth: 500,
        backgroundColor: '#1A1D23',
        borderRadius: 16,
        padding: 32,
        alignItems: 'center',
    },
    iconContainer: {
        marginBottom: 20,
    },
    iconCircle: {
        width: 80,
        height: 80,
        borderRadius: 40,
        backgroundColor: 'rgba(81, 184, 104, 0.1)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        fontSize: 24,
        fontWeight: '700',
        color: '#FFFFFF',
        marginBottom: 12,
        textAlign: 'center',
    },
    message: {
        fontSize: 16,
        color: '#8D8E90',
        textAlign: 'center',
        marginBottom: 24,
        lineHeight: 24,
    },
    benefitsList: {
        width: '100%',
        backgroundColor: '#23262B',
        borderRadius: 12,
        padding: 20,
        marginBottom: 20,
    },
    benefitsTitle: {
        fontSize: 14,
        fontWeight: '600',
        color: '#FFFFFF',
        marginBottom: 12,
    },
    benefitItem: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        marginBottom: 10,
    },
    benefitText: {
        fontSize: 14,
        color: '#FFFFFF',
    },
    emailNotice: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        backgroundColor: 'rgba(57, 190, 183, 0.1)',
        padding: 16,
        borderRadius: 8,
        marginBottom: 24,
    },
    emailNoticeText: {
        flex: 1,
        fontSize: 13,
        color: '#39BEB7',
        lineHeight: 20,
    },
    actionButtons: {
        width: '100%',
        gap: 12,
    },
    secondaryButton: {
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#39BEB7',
        alignItems: 'center',
    },
    secondaryButtonText: {
        color: '#39BEB7',
        fontSize: 14,
        fontWeight: '600',
    },
    primaryButton: {
        backgroundColor: '#39BEB7',
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 8,
        alignItems: 'center',
    },
    primaryButtonText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '700',
    },
});

export default PartnershipActivatedModal;

